import { Styles } from '@gv/triage-components';
import styled, { css } from 'styled-components';

export const Container = styled.header`
  ${Styles.flexSpaceBetween};
  padding-bottom: 24px;
  background-color: ${({ theme }) => theme.config.background};

  ${({ theme }) =>
    (theme.responsive.isMobile || theme.responsive.isTablet) &&
    css`
      padding-bottom: 16px;
      border-bottom: 1px solid ${theme.config.common.border};
    `}
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.config.common.border};
`;
